import { Component, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Subject, takeUntil } from 'rxjs';
import { setDisplayOtonOnly } from 'src/app/details/details-state/details.actions';
import { selectDisplayOtonOnly } from 'src/app/details/details-state/details.selectors';

@Component({
  standalone: false,
  selector: 'app-subtitle-transcript-filter-dialog',
  templateUrl: './subtitle-transcript-filter-dialog.component.html',
  styleUrl: './subtitle-transcript-filter-dialog.component.scss'
})
export class SubtitleTranscriptFilterDialogComponent implements OnDestroy {
  private _destroyed$: Subject<void> = new Subject<void>();

  displayOtonOnly: boolean = false;

  constructor(private ref: DynamicDialogRef, private store: Store, public config: DynamicDialogConfig) {
    this.store
      .select(selectDisplayOtonOnly)
      .pipe(takeUntil(this._destroyed$))
      .subscribe(data => {
        this.displayOtonOnly = data;
      });
  }

  setDisplayOtonOnly() {
    this.store.dispatch(
      setDisplayOtonOnly({
        displayOtonOnly: this.displayOtonOnly,
      })
    );
  }

  ngOnDestroy() {
    this._destroyed$.next();
    this._destroyed$.complete();
  }
}
